//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { OpFile } from '../models/core/op-file'
import { Enums } from '../models/common/enums'
import { TypeHelper } from './type-helper'


export class FileComponent {
    public static OpenFileSaver(toSave: OpFile): void {
        if (toSave == null || toSave.fileBytes == null)
            throw Error("OpenFileSaver - no file to save")
        var bytes = new Uint8Array(<number[]>toSave.fileBytes)
        var FileSaver = require('file-saver')
        var blob = new Blob([bytes], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, toSave.physicalFileName)
    }

    public static isImageFile(file: OpFile): boolean {
        return file.fileBytes.length != 0 &&
            (
                file.extension === Enums.FileExtension.Jpg
                || file.extension === Enums.FileExtension.Jpeg
                || file.extension === Enums.FileExtension.Png
                || file.extension === Enums.FileExtension.Bmp
            )
    }

    public static stringFromUTF8Array(data: number[]): string {
        const extraByteMap: number[] = [1, 1, 1, 1, 2, 2, 3, 0];
        const count = data.length;
        let str = "";

        for (let index = 0; index < count;) {
            let ch: number = data[index++];

            if (ch & 0x80) {
                let extra: number = extraByteMap[(ch >> 3) & 0x07];
                if (!(ch & 0x40) || !extra || ((index + extra) > count))
                    return null;

                ch = ch & (0x3F >> extra);

                for (; extra > 0; extra -= 1) {
                    const chx: number = data[index++];
                    if ((chx & 0xC0) != 0x80)
                        return null;

                    ch = (ch << 6) | (chx & 0x3F);
                }
            }

            str += String.fromCharCode(ch);
        }

        return str;
    }
}